/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { OwnableUpgradeable__factory } from "./OwnableUpgradeable__factory";
